<template>
  <div id="map-layout" :class="{ sidebar: mapLayoutSidebar }">
    <section class="topbar"></section>

    <section class="sidebar">
      <div class="mask" @click="toggleMainMenuSidebar"></div>
      <div class="sidebar-header">
        <div class="close-button d-flex justify-content-center align-items-center">
          <b-button variant="light" class="shadow-none" @click="toggleMainMenuSidebar">
            <i class="far fa-bars"></i>
          </b-button>
        </div>
        <div class="logo">
          <img src="@/assets/img/bm-logo-color.png" />
        </div>
      </div>
      <div class="sidebar-content">
        <MainMenu />
      </div>
    </section>

    <section class="main">
      <router-view />
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import MainMenu from '@/components/layout/MainMenu.vue'

@Component({
  components: {
    MainMenu
  }
})
export default class MapLayout extends Vue {
  get mapLayoutSidebar () {
    return this.$store.state.global.mapLayoutSidebar
  }

  toggleMainMenuSidebar () {
    this.$store.commit('global/toggleMapLayoutSidebar')
  }

  created () {
    if (!this.mapLayoutSidebar) {
      this.toggleMainMenuSidebar()
    }
  }
}
</script>

<style lang="scss" scoped>
#map-layout {
  height: 100%;
  background-color: #fafafa;
  display: flex;
  flex-flow: column nowrap;

  section.sidebar {
    position: fixed;
    z-index: 2;
    top: 0;
    left: calc(var(--sidebar-width) * -1);
    bottom: 0;
    width: var(--sidebar-width);
    transition: all 250ms ease-out;
    box-shadow: 0 0 5px #acacac;
    overflow: visible;
    display: flex;
    flex-flow: column nowrap;
    background-color: var(--sidebar-bg-color);
    .mask {
      content: "";
      position: fixed;
      top: 0;
      left: 0;
      right: 100%;
      bottom: 0;
      background: rgba(#000, 0.5);
      opacity: 0;
      transition: opacity 350ms ease 150ms;
    }
    .sidebar-header {
      height: 50px;
      border-bottom: 1px solid #e4e4e4;
      display: flex;
      flex-flow: row nowrap;
      .logo {
        width: 160px;
        padding: 12px 0 0 15px;
        img {
          width: 100%;
        }
      }
      .close-button {
        margin-left: 8px;
        button {
          font-size: 1.2rem;
        }
      }
    }
    .sidebar-content {
      flex: 1;
      position: relative;
    }
  }
  section.main {
    overflow-x: hidden;
    overflow-y: auto;
    height: 100%;
  }

  &.sidebar {
    section.sidebar {
      left: 0px;
      .mask {
        left: var(--sidebar-width);
        right: 0;
        opacity: 1;
      }
    }
  }
}
</style>
